import { SensorTypes } from 'commons/src/models/commonEnums';

export const homepageLink = 'https://airthings.com/';
export const publicDashboardUrl = 'dashboard';
export const localStorageKeyNumberOfTilesInWidth = 'numberOfTilesInWidth';

export const visibleSensors: SensorTypes[] = [
    SensorTypes.voc,
    SensorTypes.co2,
    SensorTypes.temp,
    SensorTypes.humidity,
    SensorTypes.pm25,
];

export const SERIAL_NUMBER_REGEX = /^\d{10}$/;

export const notUnitTopSensors: SensorTypes[] = [SensorTypes.temp, SensorTypes.humidity];
export const minScreenWidthNumberOfTiles = {
    '1': 398, // 398 (width of one tile 370 px + margin 14px * 2) + (5vw * 2) page margin
    '2': 886, // 796 (width of two tiles + margin) + (5vw * 2) page margin
    '3': 1327, // 1196 (width of three tiles + margin) + (5vw * 2) page margin
    '4': 1772, // 1592 (width of four tiles + margin) + (5vw * 2) page margin
};
